<div class="w-full flex flex-col gap-y-[100px]">
  <app-header></app-header>

  <main>
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>